const InfoIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6826 4.31875 14.6673 8.00065 14.6673C11.6826 14.6673 14.6673 11.6826 14.6673 8.00065C14.6673 6.23254 13.9649 4.53685 12.7147 3.28661C11.4645 2.03636 9.76876 1.33398 8.00065 1.33398ZM8.66732 10.6673C8.66732 11.0355 8.36884 11.334 8.00065 11.334C7.63246 11.334 7.33398 11.0355 7.33398 10.6673V7.33398C7.33398 6.96579 7.63246 6.66732 8.00065 6.66732C8.36884 6.66732 8.66732 6.96579 8.66732 7.33398V10.6673ZM7.33398 5.33398C7.33398 5.70217 7.63246 6.00065 8.00065 6.00065C8.36884 6.00065 8.66732 5.70217 8.66732 5.33398C8.66732 4.96579 8.36884 4.66732 8.00065 4.66732C7.63246 4.66732 7.33398 4.96579 7.33398 5.33398Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

export default InfoIcon;
